import { Phone, Mail, Globe, ShieldCheck, Clock } from "lucide-react";
import { InquiryForm } from "@/components/InquiryForm";
import { CONTACT } from "@/data/site";

export default function InquirePage() {
  return (
    <section className="dotgrid">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 lg:grid-cols-2 lg:px-8">
        <div>
          <span className="text-xs font-extrabold uppercase tracking-wider text-[#F97316]">Get started</span>
          <h1 className="mt-2 font-head text-4xl font-extrabold text-slate-900 sm:text-5xl">
            Request your custom quote
          </h1>
          <p className="mt-4 max-w-md text-base text-slate-600">
            Three quick steps and we'll send tailored pricing — subsidised trial, term program or holiday workshop — within <strong>4 business hours</strong>. Zero lock-in.
          </p>

          <div className="mt-6 space-y-3">
            <a href={CONTACT.phoneHref} data-testid="contact-phone" className="flex items-center gap-3 rounded-2xl bg-[#0E9E96] p-4 text-white transition-colors hover:bg-[#0b847d]">
              <span className="grid h-11 w-11 place-items-center rounded-full bg-white/15"><Phone className="h-5 w-5" /></span>
              <span><span className="block text-xs font-bold text-teal-100">Director hotline</span><span className="font-head text-xl font-extrabold">{CONTACT.phone}</span></span>
            </a>
            <div className="grid grid-cols-2 gap-3">
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 rounded-2xl border-2 border-[#E2ECEE] bg-white p-3 text-sm font-extrabold text-slate-700 hover:border-[#0E9E96]/40">
                <Mail className="h-4 w-4 text-[#F97316]" /> Email us
              </a>
              <a href={CONTACT.websiteHref} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 rounded-2xl border-2 border-[#E2ECEE] bg-white p-3 text-sm font-extrabold text-slate-700 hover:border-[#0E9E96]/40">
                <Globe className="h-4 w-4 text-[#0E9E96]" /> {CONTACT.website}
              </a>
            </div>
          </div>

          <div className="mt-6 flex flex-wrap gap-4 text-sm font-bold text-slate-600">
            <span className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-[#0E9E96]" /> WWCC verified & insured</span>
            <span className="flex items-center gap-2"><Clock className="h-4 w-4 text-[#0E9E96]" /> 4-hour response</span>
          </div>
        </div>

        <InquiryForm />
      </div>
    </section>
  );
}
